import { FC } from 'react';
import { useBanner, MaintenanceBanner } from '@unbooking/ui-kit';
import { Button, Main } from '@components';
import { ViewBookingsIcon, CollaborateIcon, TaskIcon } from '@assets/svg';
import { URLS } from '@common/constants';

import css from './styles.module.scss';

const AdminAreaEntryPage: FC = () => {
  const { bannerMessage, closeBanner } = useBanner({
    switchName: 'maintenance_notice_workshops',
    switchesUrl: `${process.env.REACT_APP_HBH_API}/v2/core/feature-flags/`,
    monolithApiKey: String(process.env.REACT_APP_HBH_KEY),
  });

  return (
    <Main withoutPaddings background='admin'>
      {bannerMessage ? <MaintenanceBanner message={bannerMessage} onClose={closeBanner} /> : null}
      <div className={css.container}>
        <div className={css.content}>
          <div className={css.title}>
            WFP <b>Workshop</b>
            <br /> Admin Area
          </div>
          <div className={css.blocks}>
            <div className={css.block}>
              <div className={css.label}>User Management</div>
              <div className={css.description}>Create new users and manage their access rights and permissions.</div>
              <div className={css.bottom}>
                <Button
                  className={css.button}
                  link={URLS.ADMIN_AREA_USERS}
                  iconR={<ViewBookingsIcon />}
                  text='Manage users'
                  variant='forest'
                />
              </div>
            </div>
            <div className={css.block}>
              <div className={css.label}>Workshop Facilities Management</div>
              <div className={css.description}>Create new workshop facilities and update facilities information.</div>
              <div className={css.bottom}>
                <Button
                  className={css.button}
                  iconR={<TaskIcon />}
                  link={URLS.ADMIN_AREA_FACILITIES}
                  text='Manage workshops'
                  variant='lochmara'
                />
              </div>
            </div>
            <div className={css.block}>
              <div className={css.label}>Customer Area Management</div>
              <div className={css.description}>
                Create and manage customer areas where users can track their requests.
              </div>
              <div className={css.bottom}>
                <Button
                  className={css.button}
                  iconR={<CollaborateIcon />}
                  // link={URLS.ADMIN_AREA_CUSTOMER_AREAS} TO DO
                  text='Manage customer areas'
                  variant='supernova'
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Main>
  );
};

export default AdminAreaEntryPage;
